export enum MessageType {
    Notification = <any> 'Notification',
    Request = <any> 'Request',
    Response = <any> 'Response'
}
